import { Component, Inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AiAgentService } from '../../../services/ai-agent.service';
import { AiConfigurationPageEventsService } from '../../../events/ai-configuration-page-events.service';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';
import { localStoragevarNames } from '../../../utilities/local-storage-utils';

@Component({
  selector: 'app-create-ai-agent-dialog',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatDividerModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    NgIf
  ],
  templateUrl: './create-ai-agent-dialog.component.html',
  styleUrl: './create-ai-agent-dialog.component.scss'
})
export class CreateAiAgentDialogComponent {
  assistantName: FormControl = new FormControl('', Validators.required);
  isLoading: boolean = false;

  constructor(
    private aiAgentPageEventService: AiConfigurationPageEventsService,
    private aiAgentService: AiAgentService,
    public dialogRef: MatDialogRef<CreateAiAgentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { subaccountId: number | undefined }) { }

  onAssistantNameCreation() {
    if (this.assistantName.valid) {
      this.isLoading = true;
      const userId = this.data.subaccountId ? this.data.subaccountId : JSON.parse(localStorage.getItem(localStoragevarNames.user)!.toString()).id;

      this.aiAgentService.createAiAgent(this.assistantName.value,userId).subscribe({
        next: (aiAgent) => {
          this.dialogRef.close();
          this.aiAgentPageEventService.onCreateNewAssistantEvent.emit(aiAgent);
        },
        error: () => {
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
  }
}
